import { v4 as uuidv4 } from "uuid";

/**
 * 文件下载工具类
 */
const JSZip = require("jszip");
/**
 * 下载单个文件到zip中
 * @param {string} url 文件的url
 * @param {JSZip} zip JSZip实例
 * @param {string} fileName 文件名
 * @param {string} fileType 文件类型
 */
const downloadImage = async (url, zip, fileName, fileType) => {
  const response = await fetch(url);
  const blob = await response.blob();
  if (fileName) {
    zip.file(fileName + "." + fileType, blob);
  } else {
    zip.file(uuidv4() + "." + fileType, blob);
  }
};

/**
 * 下载所有图片
 * @param {Array} imageItems 图片列表 [{url: string, fileName: string, fileType: string}]
 */
export async function downloadAllImages(imageItems, fileName) {
  try {
    let fileNameMap = {}; //创建个文件名存储映射，如果有相同的文件名，得在文件名后边增加个数字
    const zip = new JSZip();

    const promises = imageItems.map((item) => {
      let fileName = item.fileName;
      let fileType = item.fileType;
      if (fileName) {
        if (fileNameMap[fileName + fileType]) {
          //存在同名文件名，添加后缀
          let count = fileNameMap[fileName + fileType] + 1;
          fileNameMap[fileName + fileType] = count;
          fileName = fileName + "_" + count;
        } else {
          //目前还没同名的，先记录下
          fileNameMap[fileName + fileType] = 1;
        }
      }
      return downloadImage(item.url, zip, fileName, fileType);
    });
    await Promise.all(promises);

    const content = await zip.generateAsync({ type: "blob" });

    const a = document.createElement("a");
    a.href = window.URL.createObjectURL(content);
    a.download = (fileName ? fileName : uuidv4()) + ".zip";
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    console.log("ZIP file created and downloaded successfully.");
  } catch (error) {
    console.error("Error creating and downloading ZIP file:", error.message);
  }
}

//下载单个文件
export async function downloadSingleImage(url, fileName, fileType) {
  try {
    let xhr = new XMLHttpRequest();
    xhr.open("get", url);
    xhr.responseType = "blob";
    xhr.onload = () => {
      let mu = URL.createObjectURL(xhr.response);
      let doc = document;
      let a = doc.createElement("a");
      a.href = mu;
      a.download = fileName + "." + fileType;
      a.textContent = "download";
      doc.body.append(a);
      a.click();
      setTimeout(() => {
        a.remove();
        URL.revokeObjectURL(mu);
      }, 0);
    };
    xhr.send();
  } catch (error) {
    console.error("Error downloading image file:", error.message);
  }
}
